import { createSlice } from '@reduxjs/toolkit'

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    modalStack: [], // Stack of { modalType, modalProps }
  },
  reducers: {
    showModal: (state, action) => {
      // Push new modal onto stack
      state.modalStack.push({
        modalType: action.payload.modalType,
        modalProps: action.payload.modalProps || {},
      })
    },
    hideModal: (state) => {
      // Pop top modal from stack
      if (state.modalStack.length > 0) {
        state.modalStack.pop()
      }
    },
    hideAllModals: (state) => {
      // Clear entire stack
      state.modalStack = []
    },
  },
})

export const { showModal, hideModal, hideAllModals } = modalSlice.actions

export default modalSlice.reducer
